/**
 * makes a Promise suspense friendly by throwing if the value hasn't been
 * resolved yet.
 */
export function withSuspenseCache<T>(value: T | Promise<T>): T {
  if (typeof value === "undefined") {
    throw new Promise(() => {
      /* no-op */
    });
  }

  if (value instanceof Promise) {
    throw value;
  }

  return value as Exclude<T, undefined>;
}
